import "./App.css";
import { useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import {
  adalahKaryawanMurni, bolehMasukFinance, bolehMasukMarketing,
  keputusanAwalHalamanDepan, keputusanHalamanDepan,
} from "./lib/halamanAwal";
import Login from "./pages/Login";
import Layout from "./components/hris/Layout";
import Dashboard from "./pages/Dashboard";
import BerandaTanpaDashboard from "./pages/BerandaTanpaDashboard";
import HrisDashboard from "./pages/HrisDashboard";
import Employees from "./pages/Employees";
import Payroll from "./pages/Payroll";
import RekapPayroll from "./pages/RekapPayroll";
import Cuti from "./pages/Cuti";
import Performance from "./pages/Performance";
import Kontrak from "./pages/Kontrak";
import Master from "./pages/Master";
import Assets from "./pages/Assets";
import Divisions from "./pages/Divisions";
import AssetScan from "./pages/AssetScan";
import Users from "./pages/Users";
import OrgChart from "./pages/OrgChart";
import AttendanceReview from "./pages/AttendanceReview";
import AttendanceFotoRetensi from "./pages/AttendanceFotoRetensi";
import Documents from "./pages/Documents";
import InputNota from "./pages/InputNota";
import DownPayment from "./pages/DownPayment";
import InputNotaAkuisisi from "./pages/InputNotaAkuisisi";
import MyDashboard from "./pages/MyDashboard";
import MySlips from "./pages/MySlips";
import MyCuti from "./pages/MyCuti";
import MyReimbursement from "./pages/MyReimbursement";
import MyAttendance from "./pages/MyAttendance";
import MyProfile from "./pages/MyProfile";
import MyKpi from "./pages/MyKpi";
import MyPoin from "./pages/MyPoin";
import Attendance from "./pages/Attendance";
import LiveMap from "./pages/LiveMap";
import RekonSales from "./pages/RekonSales";
import RekonAkuisisi from "./pages/RekonAkuisisi";
import AIAssistant from "./pages/AIAssistant";
import Sales from "./pages/Sales";
import Acquisitions from "./pages/Acquisitions";
import SalesReport from "./pages/SalesReport";
import SalesTargets from "./pages/SalesTargets";
import Leaderboard from "./pages/Leaderboard";
import Projects from "./pages/Projects";
import KpiTargets from "./pages/KpiTargets";
import FinanceLayout from "./pages/finance/FinanceLayout";
import FinanceDashboard from "./pages/finance/FinanceDashboard";
import FinanceCatat from "./pages/finance/FinanceCatat";
import FinanceCOA from "./pages/finance/FinanceCOA";
import FinanceKasBank from "./pages/finance/FinanceKasBank";
import FinanceLaporan from "./pages/finance/FinanceLaporan";
import FinanceLabaKategori from "./pages/finance/FinanceLabaKategori";
import FinanceLabaGudang from "./pages/finance/FinanceLabaGudang";
import FinancePengaturan from "./pages/finance/FinancePengaturan";
import FinanceApproval from "./pages/finance/FinanceApproval";
import FinancePiutang from "./pages/finance/FinancePiutang";
import FinanceUtang from "./pages/finance/FinanceUtang";
import FinanceCreditNote from "./pages/finance/FinanceCreditNote";
import CreditNoteDetail from "./pages/finance/CreditNoteDetail";
import CashbackProgram from "./pages/finance/CashbackProgram";
import HalamanPPRute from "./pages/finance/pp/HalamanPPRute";
import CashbackClaim from "./pages/finance/CashbackClaim";
import ClaimMdr from "./pages/finance/ClaimMdr";
import ClaimMdrSrp from "./pages/finance/ClaimMdrSrp";
import CashbackClaimDetail from "./pages/finance/CashbackClaimDetail";
import MarketingDashboard from "./pages/marketing/MarketingDashboard";
import Campaigns from "./pages/marketing/Campaigns";
import CampaignDetail from "./pages/marketing/CampaignDetail";
import Kol from "./pages/marketing/Kol";
import KolDetail from "./pages/marketing/KolDetail";
import Pfp from "./pages/marketing/Pfp";
import Ads from "./pages/marketing/Ads";
import Leads from "./pages/marketing/Leads";
import PromoCodes from "./pages/marketing/PromoCodes";
import ContentCalendar from "./pages/marketing/ContentCalendar";
import KolScoreboard from "./pages/marketing/KolScoreboard";
import KolScoreDetail from "./pages/marketing/KolScoreDetail";
import MarketingBudget from "./pages/marketing/MarketingBudget";
import MarketingExpense from "./pages/marketing/MarketingExpense";
import MarketingTask from "./pages/marketing/Task";
import AdsImport from "./pages/marketing/AdsImport";
import MarketingExecutive from "./pages/marketing/MarketingExecutive";
import MarketingLayout from "./pages/marketing/MarketingLayout";
import FinanceBeban from "./pages/finance/FinanceBeban";
import FinanceReimbursement from "./pages/finance/FinanceReimbursement";
import InventoryProducts from "./pages/InventoryProducts";
import InventoryPO from "./pages/InventoryPO";
import InventoryPengaturan from "./pages/InventoryPengaturan";
import InventoryRekonPO from "./pages/InventoryRekonPO";
import MultiRekon from "./pages/MultiRekon";
import InventoryStok from "./pages/InventoryStok";
import InventoryDashboard from "./pages/InventoryDashboard";
import PriceList from "./pages/PriceList";
import PusatLaporan from "./pages/PusatLaporan";
import WaitingList from "./pages/WaitingList";
import CsatResults from "./pages/CsatResults";
import CsatSurvey from "./pages/CsatSurvey";
import CsatPengaturan from "./pages/CsatPengaturan";
import Servis from "./pages/Servis";
import Pelanggan from "./pages/Pelanggan";
import Supplier from "./pages/Supplier";
import FinanceDividen from "./pages/finance/FinanceDividen";
import FinancePersediaan from "./pages/finance/FinancePersediaan";
import FinanceAsetTetap from "./pages/finance/FinanceAsetTetap";
import FinancePettyCash from "./pages/finance/FinancePettyCash";
import FinanceAudit from "./pages/finance/FinanceAudit";
import FinanceBudget from "./pages/finance/FinanceBudget";
import FinanceRekonsiliasi from "./pages/finance/FinanceRekonsiliasi";
import FinanceCashOpname from "./pages/finance/FinanceCashOpname";
import FinanceBukuBesar from "./pages/finance/FinanceBukuBesar";
import FinanceJurnalDetail from "./pages/finance/FinanceJurnalDetail";
import ApprovalCenter from "./pages/ApprovalCenter";
import PoinKonfigurasi from "./pages/PoinKonfigurasi";
import OpnameBlind from "./pages/OpnameBlind";
import InternalMemo from "./pages/InternalMemo";
import RequestStok from "./pages/RequestStok";
import FakturSettings from "./pages/FakturSettings";
import FakturPublik from "./pages/FakturPublik";
import Pelatihan from "./pages/Pelatihan";
import LossCustomer from "./pages/LossCustomer";
import RekonUnitStok from "./pages/RekonUnitStok";
import Antrian from "./pages/Antrian";
import AntrianDisplay from "./pages/AntrianDisplay";
// Batch bos: halaman dibuat oleh agen paralel lain — didaftarkan di sini agar rute +
// menu (Layout.jsx) sudah siap begitu berkasnya muncul. Kalau berkas belum ada saat
// build ini dijalankan, import di bawah akan gagal (lihat catatan verifikasi build).
import PreOrder from "./pages/PreOrder";
import Retur from "./pages/Retur";
import Bundling from "./pages/Bundling";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-sm text-slate-500">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

/** Kartu Stok pindah jadi tab di dalam Stok & Gudang (brief owner 19 Agu poin 4,
 * lihat InventoryStok.jsx). Rute lama `/inventory/kartu-stok` TIDAK dihapus — ada
 * tautan/bookmark lama yang menaut ke sini dengan filter `?sku=...&warehouse_id=...`
 * (dulu dibaca langsung oleh KartuStok.jsx). Redirect ini membawa SELURUH query
 * string apa adanya, cuma menambah `tab=kartu-stok`, supaya filter yang dituju
 * tidak lenyap di tengah jalan — mendarat kosong tanpa penjelasan itu jebakan yang
 * sudah tercatat di memory/KEPUTUSAN-TERTUNDA.md soal restrukturisasi sidebar. */
function RedirectKartuStok() {
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams(searchParams);
  next.set("tab", "kartu-stok");
  return <Navigate to={`/inventory/stok?${next.toString()}`} replace />;
}

/** Gerbang modul Finance. Aturannya ada di `lib/halamanAwal.js::bolehMasukFinance`
 * (G8 butir b): aturan halaman awal hanya boleh memilih /finance kalau gerbang yang
 * SAMA meloloskan — dua salinan yang berbeda satu cabang saja membuat "/" dan
 * /finance saling memantul tanpa henti. Jangan menambah cabang di sini; ubah lib-nya
 * (bentuk badan fungsi ini dikunci tes AST). */
function FinanceGate() {
  const { user } = useAuth();
  return bolehMasukFinance(user) ? <FinanceLayout /> : <Navigate to="/" replace />;
}

/** Gerbang modul Marketing (brief owner 12 Agu poin 4). Aturannya ada di
 * `lib/halamanAwal.js::bolehMasukMarketing` dengan alasan yang sama dengan
 * FinanceGate di atas — termasuk pengecualian `marketing_margin` (kunci itu bukan
 * halaman, jadi pemegangnya saja tidak berhak masuk ke satu pun halaman Marketing). */
function MarketingGate() {
  const { user } = useAuth();
  if (bolehMasukMarketing(user)) return <MarketingLayout />;
  // Halaman Task adalah PENGECUALIAN yang disengaja (brief owner: "menu Task
  // untuk setiap user"). Backend sudah dibangun untuk itu sejak awal —
  // `marketing/task.py::_batas_akses_task` membatasi akun tanpa izin modul ke
  // task MILIKNYA SENDIRI, dan `list/get/update` di sana sengaja memakai
  // `get_current_user`, bukan gerbang modul.
  //
  // Tanpa pengecualian ini, staf yang DIKIRIMI tugas menekan notifikasinya lalu
  // dilempar balik ke "/" — persis keluhan owner 8 Sep 2026: "saat di klik,
  // tidak muncul apa-apa (namun task ini masuk ke dashboard)". Aturannya tetap
  // ditegakkan di backend; yang dibuka di sini hanya pintunya. Pengecualian ini
  // SENGAJA tidak ikut ke lib: ia bukan pintu ke dashboard, jadi aturan halaman
  // awal tidak boleh memilih /marketing berdasarkan jalur ini.
  if (window.location.pathname.startsWith("/marketing/tasks")) return <MarketingLayout />;
  return <Navigate to="/" replace />;
}

/** Index pohon admin ("/"): halaman awal per akun (G8 butir b, aturan di
 * `lib/halamanAwal.js`).
 *
 * "Datang" = buka aplikasi/tab baru (key router "default") atau baru login (state
 * `baruLogin` dari Login.jsx). Klik "Kembali ke HRIS" atau pantulan gerbang BUKAN
 * kedatangan — orang yang boleh melihat Sales tetap di Sales, tidak dilempar lagi.
 *
 * Keputusan kedatangan DIBEKUKAN di useState: polling /auth/me (izin berjangka)
 * mengganti objek user saat orang duduk di "/", dan menghitung ulang dengan "baru
 * datang" akan melemparnya dari Sales di tengah kerja. Kalau hasilnya tampil,
 * penanda kedatangan DIKONSUMSI dengan replace ke path yang sama (key baru, state
 * null) supaya F5/Back ke entri itu tidak terhitung datang lagi. Replace ke path
 * yang sama tidak me-remount komponen ini, jadi `awal` tetap utuh; ref menjamin
 * replace hanya sekali walau StrictMode menggandakan efek atau identitas
 * `navigate` berubah. */
function HalamanDepan() {
  const { user, can, canWidget } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [awal] = useState(() => keputusanAwalHalamanDepan(location, user, can, canWidget));
  const sudahDitandai = useRef(false);
  const { tandaiDibaca } = awal;
  const { pathname, search } = location;
  useEffect(() => {
    if (tandaiDibaca && !sudahDitandai.current) {
      sudahDitandai.current = true;
      navigate(pathname + search, { replace: true, state: null });
    }
  }, [tandaiDibaca, navigate, pathname, search]);
  const k = keputusanHalamanDepan(awal, user, can, canWidget);
  if (k.alihkan) return <Navigate to={k.alihkan} replace />;
  return k.tampil === "sales" ? <Dashboard /> : <BerandaTanpaDashboard />;
}

/** Halaman yang dibuka ORANG LUAR tanpa akun (pelanggan dari tautan WhatsApp).
 *
 * Dipisah ke komponennya sendiri dan dipasang SEBELUM RoleRoutes karena bug
 * nyata: rute /csat/:token dulu hanya terdaftar di dalam cabang `isPureEmployee`.
 * Pengunjung anonim punya `user === null`, jadi cabang itu tidak pernah dilewati;
 * tautan penilaian jatuh ke catch-all → "/" → Protected → dilempar ke /login.
 * Akibatnya SETIAP pelanggan yang mengklik tautan CSAT mendarat di halaman login
 * dan tidak pernah bisa menilai. Token di URL sudah menjadi otorisasinya
 * (sekali pakai, kedaluwarsa 14 hari) — pelanggan memang tidak boleh perlu login.
 */
function PublicRoutes({ children }) {
  const path = window.location.pathname;
  if (path.startsWith("/csat/")) {
    return (
      <Routes>
        <Route path="/csat/:token" element={<CsatSurvey />} />
      </Routes>
    );
  }
  // /faktur/:token — pelanggan membuka tautan faktur/struk dari WhatsApp tanpa
  // akun, sama persis dengan alasan /csat/ di atas: token di URL sudah jadi
  // otorisasinya sendiri, jadi harus lolos SEBELUM RoleRoutes/Protected.
  if (path.startsWith("/faktur/")) {
    return (
      <Routes>
        <Route path="/faktur/:token" element={<FakturPublik />} />
      </Routes>
    );
  }
  // Layar antrian tablet — PUBLIK tanpa login (keputusan owner 31 Agu). Halaman
  // ini hanya MENAMPILKAN nomor; ia tidak bisa membuat maupun mengubah apa pun,
  // jadi tablet boleh ditinggal berhari-hari tanpa sesi yang bisa kedaluwarsa di
  // tengah jam sibuk.
  //
  // CABANG SENDIRI, bukan di dalam cabang `/faktur/` di atas. Sampai 15 Sep 2026
  // rutenya tersisip DI DALAM cabang faktur, sehingga tidak pernah tercapai:
  // `/antrian-display/...` tidak diawali `/faktur/`, jatuh ke RoleRoutes →
  // Protected → /login. Terbukti di browser dengan profil tanpa token, lokal DAN
  // produksi — tablet yang dipasang sesuai petunjuk selalu melihat form login.
  if (path.startsWith("/antrian-display/")) {
    return (
      <Routes>
        <Route path="/antrian-display/:token" element={<AntrianDisplay />} />
      </Routes>
    );
  }
  return children;
}

function RoleRoutes() {
  const { user } = useAuth();
  // Employee dengan permission custom (via template) → pakai admin routes agar bisa akses menu.
  // Pure employee (tanpa permission) → tetap employee portal terbatas. Deteksinya satu
  // sumber dengan Layout.jsx (dulu disalin di dua tempat): lib/halamanAwal.js.
  // Role finance_* TIDAK lagi punya cabang di sini — pantulannya ke /finance kini
  // diputuskan HalamanDepan lewat aturan halaman awal yang sama dengan Login.
  const isPureEmployee = adalahKaryawanMurni(user);
  if (isPureEmployee) {
    return (
      <Routes>
        {/* /csat/:token sudah ditangani PublicRoutes di atas — berlaku untuk
            SEMUA pengunjung, termasuk yang belum login. */}
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route element={<Protected><Layout /></Protected>}>
          <Route index element={<MyDashboard />} />
          <Route path="my-attendance" element={<MyAttendance />} />
          <Route path="my-slips" element={<MySlips />} />
          <Route path="my-cuti" element={<MyCuti />} />
          <Route path="my-kpi" element={<MyKpi />} />
          <Route path="my-poin" element={<MyPoin />} />
        <Route path="my-reimbursement" element={<MyReimbursement />} />
          <Route path="projects" element={<Projects />} />
          {/* Bug lama diperbaiki sekalian (brief owner 21 Agu poin 2): menu
              "Pelatihan Saya" di employeeNav (Layout.jsx) sudah menaut ke
              /pelatihan sejak batch 11 Agu, tapi rute ini tidak pernah
              didaftarkan di sini — karyawan murni yang mengklik menunya jatuh
              ke `path="*"` di bawah dan dilempar diam-diam kembali ke Beranda
              tanpa pesan apa pun. Halamannya SENDIRI sudah aman untuk
              karyawan murni: `_batas_akses_pelatihan` (routers/pelatihan.py)
              otomatis mempersempit ke pelatihan yang diikuti sendiri untuk
              siapa pun TANPA izin `pelatihan.view` eksplisit — pola yang
              sama dengan /projects di atas — jadi cukup daftarkan rutenya. */}
          <Route path="pelatihan" element={<Pelatihan />} />
          {/* Task Marketing untuk KARYAWAN MURNI — bug yang sama persis dengan
              "Pelatihan Saya" di atas, dilaporkan owner 8 Sep 2026: task dikirim
              ke staf, notifikasinya menaut ke /marketing/tasks, tapi rute itu
              TIDAK PERNAH terdaftar di cabang ini. Akibatnya jatuh ke
              `path="*"` di bawah dan dilempar diam-diam kembali ke Beranda —
              "saat di klik, tidak muncul apa-apa".
              Halamannya sendiri aman untuk karyawan murni: backend
              (`marketing/task.py::_batas_akses_task`) otomatis mempersempit ke
              task yang ditujukan kepadanya, pola yang SAMA dengan
              `_batas_akses_pelatihan` dan /projects. */}
          <Route path="marketing/tasks" element={<MarketingTask />} />
          <Route path="my-profile" element={<MyProfile />} />
          <Route path="scan/asset/:id" element={<AssetScan />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        {/* Halaman awal per akun (G8 butir b) — lihat HalamanDepan di atas. Role
            finance_* tanpa izin Sales tetap memantul ke /finance lewat aturan lib. */}
        <Route index element={<HalamanDepan />} />
        {/* G8 uji coba (brief 15 Sep 2026): dashboard per modul. Path literal,
            tidak ada rute berparameter di bawah `dashboard/`.
            `dashboard/sales` = alias Dashboard Sales & POS yang dituju MENU: "/" di tab
            baru/bookmark adalah kedatangan dan dialihkan ke halaman awal, sedangkan
            alias ini tidak punya logika kedatangan sama sekali. */}
        <Route path="dashboard/sales" element={<Dashboard />} />
        <Route path="dashboard/hris" element={<HrisDashboard />} />
        <Route path="sales" element={<Sales />} />
        <Route path="rekon-sales" element={<RekonSales />} />
        <Route path="rekon-akuisisi" element={<RekonAkuisisi />} />
        <Route path="ai" element={<AIAssistant />} />
        <Route path="acquisitions" element={<Acquisitions />} />
        <Route path="sales-targets" element={<SalesTargets />} />
        <Route path="poin-konfigurasi" element={<PoinKonfigurasi />} />
        <Route path="kpi-custom" element={<KpiTargets />} />
        <Route path="leaderboard" element={<Leaderboard />} />
        <Route path="projects" element={<Projects />} />
        <Route path="sales-report" element={<SalesReport />} />
        <Route path="employees" element={<Employees />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="live-map" element={<LiveMap />} />
        <Route path="payroll" element={<Payroll />} />
        <Route path="rekap-payroll" element={<RekapPayroll />} />
        <Route path="cuti" element={<Cuti />} />
        <Route path="performance" element={<Performance />} />
        <Route path="kontrak" element={<Kontrak />} />
        <Route path="master" element={<Master />} />
        <Route path="assets" element={<Assets />} />
        <Route path="divisions" element={<Divisions />} />
        <Route path="scan/asset/:id" element={<AssetScan />} />
        <Route path="org-chart" element={<OrgChart />} />
        <Route path="attendance-review" element={<AttendanceReview />} />
        <Route path="attendance-foto" element={<AttendanceFotoRetensi />} />
        <Route path="documents" element={<Documents />} />
        <Route path="input-nota" element={<InputNota />} />
        <Route path="down-payment" element={<DownPayment />} />
        <Route path="input-nota-akuisisi" element={<InputNotaAkuisisi />} />
        <Route path="users" element={<Users />} />
        <Route path="approval-center" element={<ApprovalCenter />} />
        <Route path="pengaturan-faktur" element={<FakturSettings />} />
        {/* Inventory — barang fisik, gudang, PO/DO, unit ber-IMEI */}
        {/* Marketing dipindah ke layout+gerbang sendiri di bawah (MarketingGate,
            path /marketing/*) — lihat blok setelah Finance. Sidebar utama cuma
            menyisakan satu entri "Marketing" (Layout.jsx). */}

        {/* Pusat Laporan (brief owner 10 Sep 2026 poin 2). SENGAJA tanpa gerbang
            rute: halaman ini tidak punya kunci modul sendiri — isinya disaring
            per-laporan oleh backend (`/laporan/katalog` cuma mengembalikan yang
            boleh dilihat pemanggil), jadi akun tanpa izin laporan mana pun
            melihat halaman kosong, bukan data orang lain. Menunya sendiri tetap
            digerbangi daftar `mods` di Layout.jsx.
            `/laporan` (top-level) BUKAN `/finance/laporan` yang sudah ada. */}
        <Route path="laporan" element={<PusatLaporan />} />
        <Route path="inventory/dashboard" element={<InventoryDashboard />} />
        <Route path="inventory/produk" element={<InventoryProducts />} />
        <Route path="inventory/pembelian" element={<InventoryPO />} />
        <Route path="inventory/pengaturan" element={<InventoryPengaturan />} />
        <Route path="inventory/rekon-po" element={<InventoryRekonPO />} />
        <Route path="inventory/stok" element={<InventoryStok />} />
        {/* Rangkuman Price List (brief owner 10 Sep 2026 poin 1) — gerbangnya
            `inventory_produk.view`, sama dengan Master Produk: yang boleh
            melihat harga jual di master boleh melihat rangkumannya. Angka
            modal/margin digerbangi terpisah DI BACKEND (`routers/akses_
            modal.py`), dan panel "Atur Akses Modal & Margin" di halaman ini
            (tombol khusus superadmin, endpoint `require_role("superadmin")`
            di `routers/inventory/akses_modal_pengaturan.py`, brief owner
            18 Sep 2026 batch P) TIDAK punya rute sendiri — ia sebuah panel
            yang dibuka di atas halaman ini, bukan halaman terpisah. */}
        <Route path="inventory/price-list" element={<PriceList />} />
        <Route path="inventory/kartu-stok" element={<RedirectKartuStok />} />
        <Route path="inventory/rekon-unit" element={<RekonUnitStok />} />
        <Route path="inventory/bundling" element={<Bundling />} />
        <Route path="inventory/opname-blind" element={<OpnameBlind />} />
            <Route path="internal-memo" element={<InternalMemo />} />
        <Route path="request-stok" element={<RequestStok />} />
        <Route path="multi-rekon" element={<MultiRekon />} />
        <Route path="waiting-list" element={<WaitingList />} />
        {/* Loss Customer: diisi usher/security. Pelatihan dipakai DUA sisi dari satu
            rute — admin HR melihat semua, karyawan otomatis hanya melihat pelatihan
            yang ia ikuti (pembatasan di backend, sama seperti /projects). */}
        <Route path="loss-customer" element={<LossCustomer />} />
        <Route path="antrian" element={<Antrian />} />
        <Route path="pelatihan" element={<Pelatihan />} />
        <Route path="pre-order" element={<PreOrder />} />
        <Route path="retur" element={<Retur />} />
        <Route path="csat-hasil" element={<CsatResults />} />
        {/* Editor pertanyaan CSAT + template pesan WA (Fase 5.2) — izin sama
            dengan modul "csat" yang dipakai csat-hasil di atas (deps.py). Belum
            ada entri menu di Layout.jsx; dijangkau lewat tombol "Pengaturan
            Survei" di halaman Hasil CSAT. */}
        <Route path="csat-pengaturan" element={<CsatPengaturan />} />
        <Route path="servis" element={<Servis />} />
        <Route path="pelanggan" element={<Pelanggan />} />
        <Route path="supplier" element={<Supplier />} />
        {/* Portal Karyawan — accessible for user manapun yang punya link ke employee record */}
        <Route path="my-attendance" element={<MyAttendance />} />
        <Route path="my-slips" element={<MySlips />} />
        <Route path="my-cuti" element={<MyCuti />} />
        <Route path="my-kpi" element={<MyKpi />} />
        <Route path="my-poin" element={<MyPoin />} />
        <Route path="my-reimbursement" element={<MyReimbursement />} />
        <Route path="my-profile" element={<MyProfile />} />
      </Route>
      {/* Finance module — gating via FinanceGate (admin/superadmin/finance_* role/legacy master/any granular finance_*.view) */}
      <Route path="/finance" element={<Protected><FinanceGate /></Protected>}>
        <Route index element={<FinanceDashboard />} />
        <Route path="catat" element={<FinanceCatat />} />
        <Route path="catat/:jenis" element={<FinanceCatat />} />
        <Route path="coa" element={<FinanceCOA />} />
        <Route path="kas-bank" element={<FinanceKasBank />} />
        <Route path="rekonsiliasi" element={<FinanceRekonsiliasi />} />
        <Route path="cash-opname" element={<FinanceCashOpname />} />
        <Route path="buku-besar" element={<FinanceBukuBesar />} />
        {/* Detail jurnal per TRANSAKSI (sumbu kebalikan Buku Besar yang per
            AKUN) — tujuan tautan "Lihat Jurnal". Tanpa id: kotak cari +
            pemindai jurnal yang sumbernya tidak dikenali. */}
        <Route path="jurnal" element={<FinanceJurnalDetail />} />
        <Route path="jurnal/:transactionId" element={<FinanceJurnalDetail />} />
        <Route path="piutang" element={<FinancePiutang />} />
        <Route path="utang" element={<FinanceUtang />} />
        {/* Credit Note — nilai yang ditahan supplier. Halamannya hidup di bawah
            layout Finance, TAPI endpoint backendnya /api/credit-note (path literal
            di routernya sendiri), bukan /api/finance/credit-note. */}
        <Route path="credit-note" element={<FinanceCreditNote />} />
        <Route path="credit-note/:id" element={<CreditNoteDetail />} />
        {/* IMEI Cashback / Price Protection — hak cashback supplier saat harga turun,
            ditentukan per IMEI dari TANGGAL AKTIVASI. Endpoint backendnya
            /api/cashback/* (path literal di routernya sendiri). */}
        <Route path="cashback/programs" element={<CashbackProgram />} />
        {/* Menu 3 tingkat Price Protection (brief 22 Sep hal. 1–2): satu rute per
            halaman Support Aktivasi/Cashback × ZOA GROUP/Dealer Partner. Rute lama
            di atas TETAP (tautan notifikasi, Pusat Laporan, `?halaman=`). */}
        <Route path="cashback/programs/:jenis/:kanal" element={<HalamanPPRute />} />
        <Route path="cashback/claims" element={<CashbackClaim />} />
        <Route path="cashback/claims/:id" element={<CashbackClaimDetail />} />
        {/* Pengalih tautan LAMA: notifikasi deadline/missed Price Protection
            sebelum 23 Sep 2026 menaut `/finance/cashback-claim` (rute yang tidak
            pernah ada — mengkliknya melempar ke Beranda). Notifikasi itu masih
            tersimpan di database dan SENGAJA tidak disunting; rute ini
            mengarahkannya ke halaman Program. Notifikasi baru sudah menaut ke
            tujuan langsung (`alert_service.TAUTAN_HALAMAN_PROGRAM_CASHBACK`),
            dan tes PP0 menolak tautan baru yang menunjuk rute pengalih. */}
        <Route path="cashback-claim" element={<Navigate to="/finance/cashback/programs" replace />} />
        {/* Claim MDR — klaim subsidi/MDR ke leasing (brief 22 Sep butir 1:
            "Pada modul Piutang & Usaha, buat menu baru Claim MDR"). Endpoint
            backendnya /api/claim-mdr/* (path literal di routernya sendiri),
            bukan /api/finance/claim-mdr. */}
        <Route path="claim-mdr" element={<ClaimMdr />} />
        {/* Master SRP Promo — satu kunci izin `finance_claim_mdr` menaungi
            kedua halaman, pola sama dengan `inventory_po` (PETA-MODUL §5). */}
        <Route path="claim-mdr/srp" element={<ClaimMdrSrp />} />
        <Route path="beban" element={<FinanceBeban />} />
        <Route path="reimbursement" element={<FinanceReimbursement />} />
        <Route path="persediaan" element={<FinancePersediaan />} />
        <Route path="aset-tetap" element={<FinanceAsetTetap />} />
        <Route path="petty-cash" element={<FinancePettyCash />} />
        <Route path="dividen" element={<FinanceDividen />} />
        <Route path="laporan" element={<FinanceLaporan />} />
        <Route path="laba-kategori" element={<FinanceLabaKategori />} />
        <Route path="laba-gudang" element={<FinanceLabaGudang />} />
        <Route path="budget" element={<FinanceBudget />} />
        <Route path="approval" element={<FinanceApproval />} />
        <Route path="audit" element={<FinanceAudit />} />
        <Route path="pengaturan" element={<FinancePengaturan />} />
      </Route>
      {/* Marketing module — gating via MarketingGate (admin/superadmin/master toggle
          `marketing`/izin granular marketing_* apa pun, KECUALI marketing_margin).
          URL persis sama dengan sebelumnya (dulu langsung anak dari Layout) supaya
          bookmark karyawan tidak mati; hanya elemen pembungkusnya yang pindah dari
          <Layout/> ke <MarketingLayout/>. Rute detail (:id) sengaja tidak punya
          entri menu sendiri; dicapai lewat tautan dari daftarnya. */}
      <Route path="/marketing" element={<Protected><MarketingGate /></Protected>}>
        <Route index element={<MarketingDashboard />} />
        <Route path="dashboard" element={<MarketingDashboard />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="campaigns/:id" element={<CampaignDetail />} />
        <Route path="kol" element={<Kol />} />
        <Route path="kol/:id" element={<KolDetail />} />
        <Route path="pfp" element={<Pfp />} />
        <Route path="ads" element={<Ads />} />
        <Route path="leads" element={<Leads />} />
        <Route path="promo-codes" element={<PromoCodes />} />
        {/* Fase 2/3. `kol-score` sengaja BUKAN di bawah `kol/...` supaya tidak
            pernah tertangkap rute `kol/:id` di atas. */}
        <Route path="content" element={<ContentCalendar />} />
        <Route path="kol-score" element={<KolScoreboard />} />
        <Route path="kol-score/:kolId" element={<KolScoreDetail />} />
        <Route path="budget" element={<MarketingBudget />} />
        <Route path="expense" element={<MarketingExpense />} />
        <Route path="tasks" element={<MarketingTask />} />
        <Route path="ads-import" element={<AdsImport />} />
        <Route path="executive" element={<MarketingExecutive />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <PublicRoutes>
          <RoleRoutes />
        </PublicRoutes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
